/* eslint-disable */
import Accordion from '../modules/accordion';
import Breakpoint from '../modules/breakpoint';

export default node => {
    const accordion = new Accordion(node);
    const breakpoint = new Breakpoint(1024);

    breakpoint.under = () => {
        accordion.enable();
    }
    breakpoint.above = () => {
        accordion.disable();
    }
}